import { hashObject, insertCSS } from 'lib/helpers';
import {
	transitionPrefix,
	defaultEnterTimeout,
	defaultLeaveTimeout,
} from '../defaults';

const generateScaleCSS = (transition, enterScale, leaveScale) =>
`
.${transition.transitionName}-enter {
	opacity: 0 !important;
	transform: scale3d(${enterScale.sx}, ${enterScale.sy}, 1);
}
.${transition.transitionName}-enter-active {
	opacity: 1 !important;
	transform: scale3d(1, 1, 1);
	transition: opacity ${transition.transitionEnterTimeout}ms ease, transform ${transition.transitionEnterTimeout}ms ease;
}
.${transition.transitionName}-leave {
	opacity: 1 !important;
	transform: scale3d(1, 1, 1);
}
.${transition.transitionName}-leave-active {
	opacity: 0 !important;
	transform: scale3d(${leaveScale.sx}, ${leaveScale.sy}, 1);
	transition: opacity ${transition.transitionLeaveTimeout}ms ease, transform ${transition.transitionLeaveTimeout}ms ease;
}
`;

const setupTransitions = {};

/**
 * generate a scale3d transition, enjoy it with ReactCSSTransitionGroup
 */
export default function scale({
	enterScale = { sx: .1, sy: .1 },
	leaveScale = enterScale,
	enterTimeout = defaultEnterTimeout,
	leaveTimeout = defaultLeaveTimeout,
} = {}) {

	const name = transitionPrefix + 'scale';
	const hash = hashObject({ name, enterScale, leaveScale, enterTimeout, leaveTimeout });

	if (!setupTransitions[hash]) {
		const transition = setupTransitions[hash] = {
			transitionName: name + hash,
			transitionEnterTimeout: enterTimeout,
			transitionLeaveTimeout: leaveTimeout,
		};

		const css = generateScaleCSS(transition, enterScale, leaveScale);
		insertCSS(name + hash, css);
	}

	return setupTransitions[hash];
}



// WEBPACK FOOTER //
// ./lib/helpers/transition/effects/scale.js